import { apiFetch } from '@/shared/api/client'
import { isMockApi } from '@/shared/env'

export type ApiPlanLine = {
  product_name: string
  target_qty: number
  uom: string
  category_name: string
  category_sort_order: number
}

export type ApiMergedPlanLine = {
  product_name: string
  target_qty: number
  produced_qty: number
  uom: string
  category_name: string
  category_sort_order: number
}

export type ApiPlanItem = {
  plan_id: string
  plan_code: string
  plan_seq: number
  notes?: string
  status: string
  lines: ApiPlanLine[]
}

export type ApiTodayPlan = {
  plan_date: string
  plans: ApiPlanItem[]
  merged_lines: ApiMergedPlanLine[]
}

export type ApiSessionLine = {
  product_name: string
  plan_qty: number | null
  qty: number
  source: 'plan' | 'off_plan'
}

export type ApiProductionSession = {
  ref: string
  session_code: string
  status: 'draft' | 'in_progress' | 'posted'
  updated_at: string
  note?: string
  lines: ApiSessionLine[]
}

export type ApiTodaySessions = {
  sessions: ApiProductionSession[]
}

export async function fetchTodayProductionPlan(deviceId: string): Promise<ApiTodayPlan> {
  const encoded = encodeURIComponent(deviceId)
  return apiFetch<ApiTodayPlan>(`/kitchen/production-plans/today?device_id=${encoded}`)
}

export async function fetchTodayProductionSessions(deviceId: string): Promise<ApiTodaySessions> {
  const encoded = encodeURIComponent(deviceId)
  return apiFetch<ApiTodaySessions>(`/kitchen/production-sessions/today?device_id=${encoded}`)
}

export function shouldUseProductionApi(): boolean {
  return !isMockApi
}
